"use client";

import React from "react";
const stats = [{
  value: "98%",
  label: "Guest Satisfaction"
}, {
  value: "24/7",
  label: "Guest Support"
}, {
  value: "50+",
  label: "Prime Locations"
}, {
  value: "100%",
  label: "Reliability"
}];
export default function ByTheNumbers() {
  return <section id="by-the-numbers" className="dark bg-background text-foreground py-24 md:py-48 relative overflow-hidden">
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes ticker-scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-ticker {
            animation: ticker-scroll 30s linear infinite;
            display: flex;
            width: max-content;
          }
        `
    }} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {}
        <div className="hidden md:block absolute top-[calc(clamp(2.5rem,8vw,5.5rem)/2)] left-4 right-4 h-px bg-border z-0"></div>

        <div className="grid grid-cols-2 md:grid-cols-12 gap-y-16 gap-x-4 md:gap-x-8 relative z-10">
          {stats.map((stat, i) => <div key={i} data-index={i} className="col-span-1 md:col-span-3 flex flex-col items-center text-center relative">
              {}
              <div className="md:hidden absolute top-[calc(clamp(2.5rem,8vw,5.5rem)/2)] left-0 w-full h-px bg-border z-0"></div>

              <div className="relative z-10 bg-background px-3 md:px-6 inline-block">
                <span className="block text-primary font-default text-[clamp(2.5rem,8vw,5.5rem)] font-medium tracking-tight leading-[1.1]">
                  {stat.value}
                </span>
              </div>
              <span className="mt-6 font-mono text-[0.75rem] font-semibold tracking-[0.15em] uppercase text-muted-foreground">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden border-t border-border bg-background py-2 flex z-20">
        <div className="animate-ticker">
          {[...Array(8)].map((_, i) => <span key={i} data-index={i} className="font-mono text-[10px] font-semibold tracking-[0.15em] uppercase text-muted-foreground mx-4 whitespace-nowrap">
              COMFORT &bull; RELIABILITY &bull; CLEANLINESS &bull;
            </span>)}
        </div>
      </div>
    </section>;
}